var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookmarkwithCircle = function SvgBookmarkwithCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181800",
    fillRule: "evenodd",
    d: "M14.853 2.25a4.5 4.5 0 0 0 3.897 6.243v11.353c0 1.094-1.307 1.66-2.105.912L12 16.403l-4.645 4.355c-.798.748-2.105.182-2.105-.912V3.5c0-.69.56-1.25 1.25-1.25z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 4,
    r: 3,
    fill: "#BDD900"
  })));
};
export { SvgBookmarkwithCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIGZpbGw9IiMxODE4MDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0Ljg1MyAyLjI1YTQuNSA0LjUgMCAwIDAgMy44OTcgNi4yNDN2MTEuMzUzYzAgMS4wOTQtMS4zMDcgMS42Ni0yLjEwNS45MTJMMTIgMTYuNDAzbC00LjY0NSA0LjM1NWMtLjc5OC43NDgtMi4xMDUuMTgyLTIuMTA1LS45MTJWMy41YzAtLjY5LjU2LTEuMjUgMS4yNS0xLjI1aDguMzUzWiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PGNpcmNsZSBjeD0iMTkiIGN5PSI0IiByPSIzIiBmaWxsPSIjQkREOTAwIi8+PC9zdmc+";